import { authHeader } from '../utils';
import jwt_decode from 'jwt-decode'; // eslint-disable-line camelcase

export const userService = {
  login,
  logout,
  create,
  deleteUser,
  getAll,
  updateStatus,
  updatePassword,
  resetPassword,
};

function login(name, password) {
  const requestOptions = {
    method: 'POST',
    headers: [['Content-Type', 'application/json']],
    body: JSON.stringify({ name, password }),
  };

  return fetch('/api/login', requestOptions)
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then(token => {
      // login successful if there's a jwt token in the response
      if (token && token.value) {
        // store jwt token in local storage to keep user logged in between page refreshes
        var user = jwt_decode(token.value);
        user.token = token.value;
        window.sessionStorage.setItem('disserto_user', JSON.stringify(user));
      }

      return user;
    });
}

function logout() {
  // remove user from local storage to log user out
  console.log('Deleting user');
  window.sessionStorage.removeItem('disserto_user');
}

function create(user) {
  let newUser = {
    firstname: user.firstname,
    lastname: user.lastname,
    email: user.email,
    lang: user.lang,
    loginParameters: {
      name: user.login,
      password: user.password,
    },
  };
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(newUser),
  };

  return fetch('/api/users', requestOptions).then(handleResponse);
}

function getAll(pageNumber) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(
    '/api/users?limit=40&sort=%2Bstatus,%2Blastname&status=ALL&page=' +
      pageNumber,
    requestOptions
  ).then(response => handlePaginatedResponse(response, pageNumber));
}

function updateStatus(userId, status, currentPage) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: status,
  };
  return fetch('/api/users/' + userId + '/status', requestOptions).then(
    response => {
      if (!response.ok) {
        return Promise.reject(response.status);
      } else {
        return getAll(currentPage);
      }
    }
  );
}

function deleteUser(userId, currentPage) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
  };
  return fetch('/api/users/' + userId, requestOptions).then(response => {
    if (!response.ok) {
      return Promise.reject(response.status);
    } else {
      return getAll(currentPage);
    }
  });
}

function updatePassword(userId, oldPassword, newpassword) {
  let data = {
    actual: oldPassword,
    new: newpassword,
  };
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch('/api/users/' + userId + '/password', requestOptions).then(
    response => {
      if (!response.ok) {
        return Promise.reject(response.status);
      } else {
        return response.blob();
      }
    }
  );
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  } else {
    return response.json();
  }
}

function handlePaginatedResponse(response, pageNumber) {
  if (!response.ok) {
    return Promise.reject(response.status);
  } else {
    return response
      .json()
      .then(json => ({
        headers: response.headers,
        json,
      }))
      .then(({ headers, json }) => {
        let result = {
          nbPages: headers.get('x-orange-total-pages'),
          nbUsers: headers.get('x-orange-total-items'),
          users: json,
          currentPage: pageNumber,
        };
        return result;
      });
  }
}

function resetPassword(userId) {
  let newpassword = Math.random()
    .toString(36)
    .substring(2, 15);
  let data = {
    new: newpassword,
  };
  const requestOptions = {
    method: 'PATCH',
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch('/api/users/' + userId + '/password', requestOptions).then(
    response => {
      if (!response.ok) {
        return Promise.reject(response.status);
      } else {
        return response.blob();
      }
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/user.service.js